const CRM = ({ color = '#E9BF6E', width = 24, height = 25 }: { color?: string; width?: number; height?: number }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 17.1797L13 19.1797C13.197 19.3767 13.4308 19.5329 13.6882 19.6395C13.9456 19.7461 14.2214 19.801 14.5 19.801C14.7786 19.801 15.0544 19.7461 15.3118 19.6395C15.5692 19.5329 15.803 19.3767 16 19.1797C16.197 18.9827 16.3532 18.7489 16.4598 18.4915C16.5665 18.2341 16.6213 17.9583 16.6213 17.6797C16.6213 17.4011 16.5665 17.1253 16.4598 16.8679C16.3532 16.6105 16.197 16.3767 16 16.1797"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0002 14.1797L16.5002 16.6797C16.8981 17.0775 17.4376 17.301 18.0002 17.301C18.5628 17.301 19.1024 17.0775 19.5002 16.6797C19.8981 16.2819 20.1215 15.7423 20.1215 15.1797C20.1215 14.6171 19.8981 14.0775 19.5002 13.6797L15.6202 9.7997C15.0577 9.2379 14.2952 8.92234 13.5002 8.92234C12.7052 8.92234 11.9427 9.2379 11.3802 9.7997L10.5002 10.6797C10.1024 11.0775 9.56284 11.301 9.00023 11.301C8.43762 11.301 7.89805 11.0775 7.50023 10.6797C7.1024 10.2819 6.87891 9.74231 6.87891 9.1797C6.87891 8.61709 7.1024 8.07753 7.50023 7.6797L10.3102 4.8697C11.2225 3.95985 12.4121 3.38025 13.6909 3.22268C14.9696 3.0651 16.2644 3.33853 17.3702 3.9997L17.8402 4.2797C18.266 4.53669 18.7723 4.62582 19.2602 4.5297L21.0002 4.1797"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 3.17969L22 14.1797H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3 3.17969L2 14.1797L8.5 20.6797C8.89782 21.0775 9.43739 21.301 10 21.301C10.5626 21.301 11.1022 21.0775 11.5 20.6797C11.8978 20.2819 12.1213 19.7423 12.1213 19.1797C12.1213 18.6171 11.8978 18.0775 11.5 17.6797"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 4.17969H11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CRM;
